var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDomain } from 'core/domain/common';
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile(avatar, fullName, banner, tagLine, creationDate, firstTime, email, birthday, webUrl, companyName, twitterId, DefaultSize, ShippingAddress, HTVerified, isDesigner, 
    /* tslint:disable */
    merchant_Id, userName, city, zip
    // justin added fields
    // public isDesigner?: Boolean,
    // public Address?: string,
    // public Location?: string,  
    ) {
        var _this = _super.call(this) || this;
        _this.avatar = avatar;
        _this.fullName = fullName;
        _this.banner = banner;
        _this.tagLine = tagLine;
        _this.creationDate = creationDate;
        _this.firstTime = firstTime;
        _this.email = email;
        _this.birthday = birthday;
        _this.webUrl = webUrl;
        _this.companyName = companyName;
        _this.twitterId = twitterId;
        _this.DefaultSize = DefaultSize;
        _this.ShippingAddress = ShippingAddress;
        _this.HTVerified = HTVerified;
        _this.isDesigner = isDesigner;
        _this.merchant_Id = merchant_Id;
        _this.userName = userName;
        _this.city = city;
        _this.zip = zip;
        return _this;
    }
    return Profile;
}(BaseDomain));
export { Profile };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/users/profile.ts
// module id = 643
// module chunks = 50